function flickityAdjust(){

  var filterby = []
  $(".product-form__variants input:checked").each(function( ) {  
      filterby.push($(this).val().replace(" ", "_").toLowerCase())
  });

  if(filterby.length > 0){
    
      //DEAL WITH THE THUMBNAILS 
      $(".flickity-nav").each(function( ) {
        var image_select = $(this).attr("data-select").split(",")
         
          if(image_select == ""){
            // NOTHING TO DO
          }else{          
              var resultcounter = 0
              for(var i = 0; i < image_select.length; i++){ 
                if(jQuery.inArray(image_select[i], filterby) !== -1){ 
                   resultcounter++;
                }else{               
                    resultcounter--;
                }          
              }            
              if(resultcounter > 0){
                  $(this).show() 
              }else{
                 $(this).hide()  
              }                   
          } 
      })

      //DEAL WITH THE MAIN IMAGES
      $(".product__media-item").each(function( ) {
        var image_select = $(this).attr("data-select").split(",")
       
          if(image_select == ""){
              //NOTHING TO DO
          }else{  
              var resultcounter = 0
              for(var i = 0; i < image_select.length; i++){ 
                  if(jQuery.inArray(image_select[i], filterby) !== -1){
                     resultcounter++;
                  }else{               
                      resultcounter--;
                  }          
              }           
              if(resultcounter > 0){
                  $(".product__media-list-wrapper").detach($(this))
                  $(".flickity-slider").append($(this).removeClass("hidden hidden-image"))  
              }else{
                  $(this).addClass("hidden hidden-image").detach()
                  $(".product__media-list-wrapper").append($(this))  
              }       
          }
      })
    
  }
}


$(".shopify-product-form").on("change", function(){ 
  flickityAdjust()  
})

flickityAdjust()  










 